require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-mum-running-safely.json") })
        }
      }, "path---blog-mum-running-safely");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-mum-running-safely!./.cache/json/blog-mum-running-safely.json
// module id = 300
// module chunks = 231608221292675